<template>
  <div class="filter commodity-filter">
    <h2>{{ this.$t("message.home.classification" /**分类 */) }}</h2>
    <ul>
      <!-- <li
        :class="{
          'commodity-filter-item': true,
          'commodity-filter-item-active': currentFilterValue === 'explme',
        }"
        class="first-item"
        @click="changeFilter('explme', 'explme')"
      >
        {{ $t("message.home.AllProducts") }}
      </li> -->
      <li v-for="(item, index) in objsList" :key="index" :class="{
        'commodity-filter-item': true,
        'commodity-filter-item-active': currentFilterValue === index,
      }" @click="changeFilter(item, index)">
        <div class="list" @click="openList = !openList">
          {{ item.name }}
          <i :class="openList && parCategoryId == item.id
            ? 'el-icon-arrow-down'
            : 'el-icon-arrow-right'
            " v-if="item.children.length" style="margin-left: 5px"></i>
        </div>
        <div class="list-item" v-if="openList && parCategoryId == item.id">
          <ul v-if="item.children.length">
            <li v-for="(subItem, subIndex) in item.children" :key="subIndex"
              @click.stop="changeFilter(item, subIndex, subItem)"
              :class="subItem.id == categoryId ? 'active' : ''">
              {{ subItem.name }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import { CategoryApiList } from "@/api/home";
import {
  index
} from "@/api/goods/goods_category.js"
export default {
  name: "EsFilter",
  data() {
    return {
      currentFilterValue: "",
      categoryList: [],
      openList: false,
      categoryId: "",
      parCategoryId: "",
      scrollTop: 0,

      //////////////////////////////////////////////////////////////////////


      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      treeChildren: [],
      // 数据缓存
      currType: 0,
      activeIndex: 0,
      typeTree: [],
      bigTypes: [],
      typeName: "",
      typeIndex: 1


      //////////////////////////////////////////////////////////////////////
    };
  },
  computed: {
    // ...mapGetters("home", ["categoryList"]),
  },
  activated() {
    // this.getCategoryList();
    // const currentRouter = this.$router.currentRoute;
    // window.addEventListener("scroll", this.windowScroll);
    // setTimeout(() => {
    //   if (this.categoryList.length) {
    //     if(currentRouter.query.parentId){
    //       const index = this.categoryList.findIndex(
    //         (item) => item.categoryId === currentRouter.query.parentId
    //       );
    //         this.currentFilterValue = index;
    //         this.parCategoryId = currentRouter.query.parentId;
    //         this.categoryId = currentRouter.query.id;
    //         this.openList = true

    //     } else if (currentRouter.query.id) {
    //       this.openList = false
    //       localStorage.setItem("category_id", currentRouter.query.id);
    //       this.$emit(
    //         "filterChange",
    //         this.categoryList.find(
    //           (item) => item.categoryId === currentRouter.query.id
    //         ).categoryId
    //       );
    //       const index = this.categoryList.findIndex(
    //         (item) => item.categoryId === currentRouter.query.id
    //       );
    //       if (index) {
    //         this.currentFilterValue = index;
    //       }
    //     } else {
    //       this.currentFilterValue = "explme";
    //     }
    //   }
    // }, 1000);


    this.goods_category_index();
  },
  created() {
    // EventBus.$on("sort", (data) => {
    //   console.log("data ->", data);
    // });
  },
  methods: {
    ...mapActions("home", ["requestCategoryList"]),

    goods_category_index() {
      // let	 res = await	index();
      index().then(response => {
        this.objsList = response.data.data;
        // this.treeChildren = this.objsList[0].children;
        // this.objsList[0].status = "active";
      }).catch(error => {

      })



    },

    // windowScroll() {
    //     this.scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop
    // },
    async getCategoryList() {
      // const res = await CategoryApiList();
      // this.categoryList = res.data.filter((item) => {
      //   if (item.name && item.subList.length > 0) {
      //     item.subList = item.subList.filter((subItem) => subItem.name);
      //   }
      //   return item.name;
      // });
      // this.categoryList = res.data;
    },
    changeFilter(item, index, subItem) {
      const currentRouter = this.$router.currentRoute;
      this.categoryId = "";
      if (subItem) {
          this.categoryId = subItem.id;
          this.$emit("filterChange", subItem);
      } else {
          this.parCategoryId = item.id;
          this.currentFilterValue = index;
          this.$emit("filterChange", item);
      }
    },
  },
};
</script>

<style lang="scss">
html[dir="rtl"] {
  .first-item {
    text-align: right;
  }

  .commodity-filter h2 {
    text-align: center;
  }
}

.commodity-filter {
  width: 180px;
  border-right: 1px solid var(--color-border);

  h2 {
    width: 100%;
    // text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: var(--color-title);
    border-bottom: 1px solid var(--color-border);
    padding: 20px 0;
    margin-bottom: 20px;
  }

  .first-item {
    text-align: left;
    font-size: 14px;
  }

  &-item {
    // text-align: center;
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    color: var(--color-black);
    padding: 20px 0;
    cursor: pointer;

    &:hover {
      color: var(--color-main);
      border-right: 2px solid var(--color-main);
    }

    &-active {
      color: var(--color-main);
      border-right: 2px solid var(--color-main);
    }

    .list {
      display: flex;
      // justify-content: space-between;
      align-items: center;
    }

    .list-item {
      margin-top: 15px;

      li {
        text-indent: 10px;
        font-size: 12px;
        padding: 5px 0;
        color: var(--color-black) !important;

        &:hover {
          color: var(--color-main) !important;
          // border-right: 2px solid var(--color-main);
        }

        &.active {
          color: var(--color-main) !important;
          // border-right: 2px solid var(--color-main);
        }
      }
    }
  }
}
</style>
